import { render } from "./BatchEditDialog.vue?vue&type=template&id=2db03d3a&scoped=true"
import script from "./BatchEditDialog.vue?vue&type=script&lang=js"
export * from "./BatchEditDialog.vue?vue&type=script&lang=js"

import "./BatchEditDialog.vue?vue&type=style&index=0&id=2db03d3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db03d3a"]])

export default __exports__